// extracted by mini-css-extract-plugin
export default {"root":"KeyValueModal_root__cnBtL","row":"KeyValueModal_row__sK1Li","rowDescription":"KeyValueModal_rowDescription__T9Y3T","rowValue":"KeyValueModal_rowValue__5ySvN"};